import { render, staticRenderFns } from "./AddProjectToPackage.vue?vue&type=template&id=6a10eb5a&"
import script from "./AddProjectToPackage.vue?vue&type=script&lang=js&"
export * from "./AddProjectToPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports